import { BaseEntity, getCachedSolarSystemEntity } from ".";
import { IGet_corporations_corporation_id_structures_200_ok } from "../service/esiclient";
import { getCachedCorporationEntity } from "./CorporationEntityCache";
import moment from "moment";

export class CorporationStructureEntity extends BaseEntity {
  private _corporation_id: number;
  constructor(id: number, props: any, corporation_id: number, character_id: number) {
    super(id, props);
    this._corporation_id = corporation_id;
    this._character_id = character_id;
    this._dataTypeName = "Corporation Structure";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    //This dataset is very basic
    const props: Partial<IGet_corporations_corporation_id_structures_200_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      if (props.services && props.services.length) {
        let services_array: Excel.CellValue[][] = [];
        props.services.forEach((service) => {
          services_array.push([
            {
              type: Excel.CellValueType.entity,
              text: service.name + " - " + service.state,
              properties: {
                name: {
                  type: Excel.CellValueType.string,
                  basicValue: service.name,
                },
                state: {
                  type: Excel.CellValueType.string,
                  basicValue: service.state,
                },
              },
            },
          ]);
        });
        entity.properties["services"] = {
          type: Excel.CellValueType.array,
          elements: services_array,
        };
      }
      if (props.next_reinforce_apply) {
        const next_reinforce_apply = moment(props.next_reinforce_apply);
        entity.properties["next_reinforce_apply"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: next_reinforce_apply.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.fuel_expires) {
        const fuel_expires = moment(props.fuel_expires);
        entity.properties["fuel_expires"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: fuel_expires.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.state_timer_start) {
        const state_timer_start = moment(props.state_timer_start);
        entity.properties["state_timer_start"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: state_timer_start.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.state_timer_end) {
        const state_timer_end = moment(props.state_timer_end);
        entity.properties["state_timer_end"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: state_timer_end.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      delete entity.properties["structure_id"];
      const corpEntity = await getCachedCorporationEntity(this._corporation_id);
      if (corpEntity !== null) {
        entity.properties["owner"] = await corpEntity.toJson();
      }
      if (props.corporation_id == this._corporation_id && corpEntity !== null) {
        entity.properties["corporation"] = await corpEntity.toJson();
        delete entity.properties["corporation_id"];
      } else if (props.corporation_id) {
        const corpEntity2 = await getCachedCorporationEntity(props.corporation_id);
        if (corpEntity2 !== null) {
          entity.properties["corporation"] = await corpEntity2.toJson();
          delete entity.properties["corporation_id"];
        }
      }
      let structureName = "Structure";
      if (props.name) structureName = props.name;
      entity.text = structureName;
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
      if (props.system_id) {
        const systemEntity = await getCachedSolarSystemEntity(props.system_id);
        if (systemEntity != null) {
          entity.properties["system"] = await systemEntity.toJson();
          delete entity.properties["system_id"];
        }
      }
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
